export default __webpack_public_path__ + "static/media/livecase1.c92133b4.png";